<div class="modal-body">
  <form [formGroup]="form">
    @if (form && validation) {
      <div class="row">
        <rask-input-number
          label="Avstånd närmaste industri"
          aid="avstandNarmasteIndustriJusterat"
          formControlName="avstandNarmasteIndustriJusterat"
          unit="km"
          [step]="1"
          [min]="0"
          [rule]="validation.avstandNarmasteIndustriJusterat"
          [placeholder]="vm.avstandNarmasteIndustri"
        ></rask-input-number>
      </div>
    }
  </form>
</div>
<div class="modal-footer">
  <rask-button color="primary" (click)="save()" [disabled]="!canSave()">Spara</rask-button>
  <rask-button color="secondary" (click)="dismiss()">Avbryt</rask-button>
</div>
